import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog.jsx'
import { Icon } from '@iconify/react'
import { TypographyP, TypographySmallMuted } from '@/components/ui/typography.jsx'
import { Badge } from '@/components/ui/badge'

export const NewReportDialog = ({ isDialogOpen, setIsDialogOpen, onCreateNewReport }) => {
    return (
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
            <DialogContent className="">

                <DialogDescription />
                <DialogHeader>
                    <div className="flex items-center gap-2">
                        <DialogTitle>Create New Report</DialogTitle>
                        <a
                            href="https://help.upspring.ai/en/articles/12791845-report-types"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-xs text-muted-foreground hover:underline flex items-center gap-1"
                        >
                            Learn more
                            <Icon icon="lets-icons:external" className="h-4 w-4" />
                        </a>
                    </div>
                </DialogHeader>
                <div className="flex flex-col">

                    <div className="flex items-center gap-4 transition cursor-pointer hover:bg-accent p-4 rounded" onClick={() => onCreateNewReport('top-performing')}>
                        <Icon icon="ph:medal" className="h-10 w-10 flex-shrink-0 border p-2 rounded-full text-gray-500 border-gray-500" />
                        <div>
                            <TypographyP>Top Performing</TypographyP>
                            <TypographySmallMuted>
                                See which creatives are achieving the best performance
                            </TypographySmallMuted>
                        </div>
                    </div>

                    <div className="flex items-center gap-4 transition cursor-pointer hover:bg-accent p-4 rounded" onClick={() => onCreateNewReport('custom-groups-comparison')}>
                        <Icon icon="ph:stack" className="h-10 w-10 flex-shrink-0 border p-2 rounded-full text-secondary-500 border-secondary-500" />
                        <div>
                            <TypographyP>Custom Groups Comparison</TypographyP>
                            <TypographySmallMuted>
                                Evaluate multiple sets of creatives against each other by filtering through custom groups
                            </TypographySmallMuted>
                        </div>
                    </div>

                    <div className="flex items-center gap-4 transition cursor-pointer hover:bg-accent p-4 rounded" onClick={() => onCreateNewReport('launch')} data-intercom-target="create-new-launch-report-button">
                        <Icon icon="ph:rocket" className="h-10 w-10 flex-shrink-0 border p-2 rounded-full text-primary border-primary" />
                        <div>
                            <TypographyP className="flex items-center gap-2">
                                Launch Report
                            </TypographyP>
                            <TypographySmallMuted>
                                Track and analyze ads launched since a specific date with customizable segments
                            </TypographySmallMuted>
                        </div>
                    </div>


                </div>
            </DialogContent>
        </Dialog>
    )
}